var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthreport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 5a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1zM11 33h4v2h-4zM17 33h15v2H17zM11 39h4v2h-4zM11 45h4v2h-4zM11 51h4v2h-4z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 35h-1a15.113 15.113 0 0 1-9-3l-2.4-1.8a.99.99 0 0 0-1.2 0L46 31.25V11a3.009 3.009 0 0 0-3-3h-8.18A3.01 3.01 0 0 0 32 6h-2.34a6 6 0 0 0-11.32 0H16a3.01 3.01 0 0 0-2.82 2H5a3.009 3.009 0 0 0-3 3v48a3.009 3.009 0 0 0 3 3h38a3.016 3.016 0 0 0 2.35-1.15l2.22 1.05a.975.975 0 0 0 .86 0l8.78-4.17A8.961 8.961 0 0 0 62 49.78V36a1 1 0 0 0-1-1zM35 10h8a1 1 0 0 1 1 1v21.69a15.237 15.237 0 0 1-2 1.05V13a1 1 0 0 0-1-1h-6zM15 9a1 1 0 0 1 1-1h3.1a.988.988 0 0 0 .98-.8 4 4 0 0 1 7.84 0 .988.988 0 0 0 .98.8H32a1 1 0 0 1 1 1v4H15zm-1 6h20a1 1 0 0 0 1-1h5v20.44a15.03 15.03 0 0 1-4 .56h-1a1 1 0 0 0-1 1v3H17v2h17v4H17v2h17v2.78a9.867 9.867 0 0 0 .08 1.22H17v2h17.61a9.027 9.027 0 0 0 1.91 3H8V14h5a1 1 0 0 0 1 1zm29 45H5a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h8v2H7a1 1 0 0 0-1 1v44a1 1 0 0 0 1 1h32.36l4.02 1.91A1.007 1.007 0 0 1 43 60zm17-10.22a6.953 6.953 0 0 1-3.69 6.16L48 59.89l-8.29-3.94A6.975 6.975 0 0 1 36 49.78V37a17.1 17.1 0 0 0 10.2-3.4l1.8-1.35 1.8 1.35A17.1 17.1 0 0 0 60 37z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 21h-3v-3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3h-3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zm-1 4h-3a1 1 0 0 0-1 1v3h-2v-3a1 1 0 0 0-1-1h-3v-2h3a1 1 0 0 0 1-1v-3h2v3a1 1 0 0 0 1 1h3zM57.15 38.78a19.042 19.042 0 0 1-8.55-3.58.99.99 0 0 0-1.2 0 19.042 19.042 0 0 1-8.55 3.58 1.008 1.008 0 0 0-.85.99v10.01a4.994 4.994 0 0 0 2.58 4.37l.06.03 6.93 3.29a.975.975 0 0 0 .86 0l6.99-3.32A5.006 5.006 0 0 0 58 49.78V39.77a1.008 1.008 0 0 0-.85-.99zm-1.15 11a2.959 2.959 0 0 1-1.5 2.59L48 55.46l-6.48-3.07A3 3 0 0 1 40 49.78v-9.17a21.108 21.108 0 0 0 8-3.38 21.108 21.108 0 0 0 8 3.38z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.707 47.293-1.414 1.414 3 3a1 1 0 0 0 1.414 0l8-8-1.414-1.414L46 49.586z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthreport);
export default __webpack_public_path__ + "static/media/healthreport.a9be52d5a7437dc323eba740dfbad32e.svg";
export { ForwardRef as ReactComponent };